module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiPgogICAgPHBvbHlsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzU3QUQ4RCIgc3Ryb2tlLXdpZHRoPSIyIiBwb2ludHM9IjEzOTYuNjQyIDQyLjM0OCAxNDAxLjIyMyA0Ny4zNDggMTQwNi4xNjEgNDIuMzQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM5NSAtNDEpIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/arrow-profile.svg
// module id = ba8D
// module chunks = 1